import { render, staticRenderFns } from "./IconManagementDialog.vue?vue&type=template&id=5622932c&scoped=true&"
import script from "./IconManagementDialog.vue?vue&type=script&lang=js&"
export * from "./IconManagementDialog.vue?vue&type=script&lang=js&"
import style0 from "./IconManagementDialog.vue?vue&type=style&index=0&id=5622932c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622932c",
  null
  
)

export default component.exports